<template>
  <base-section
    id="features"
    class="secondary"
  >
    <!--
    OTHER ORGANIZATIONS
    -->
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
          >
            <h1 class="text-center blue--text pb-4">
              Organizations We Complement
            </h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="6"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>

      <span class="trace">sections/Orgs.vue</span>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionOrgs',

    data: () => ({
      cards: [
        {
          icon: 'mdi-home',
          title: 'Truro Committees',
          text: 'Select Board appointed Committees',
          html: '<a href="https://www.truro-ma.gov/energy-committee" target="_page2">Energy</a><br><a href="https://www.truro-ma.gov/climate-action-committee" target="_page2">Climate Action</a> <br> <a href="https://www.truro-ma.gov/water-resources-oversight-committee" target="_page2">Water Resources Oversight</a> <br> <a href="https://www.truro-ma.gov/recycling-committee" target="_page2">Recycling</a> <br>      <a href="https://www.truro-ma.gov/agricultural-commission" target="_page2">Agricultural Commission</a> <br> <a href="https://www.truro-ma.gov/conservation-commission" target="_page2">Conservation</a>  <br>           <a href="https://www.truro-ma.gov/local-comprehensive-plan-committee" target="_page2">Local Comprehensive Plan</a> <br> <a href="https://www.truro-ma.gov/open-space-committee" target="_page2">Open Space</a> <br> <a href="https://www.truro-ma.gov/housing-authority" target="_page2">Housing Authority</a>',
        },
        {
          icon: 'mdi-foot-print',
          title: 'Truro Non-Profits',
          text: 'Non-profits in Truro',
          html: '<a href="http://truroconservationtrust.org" target="_page2">Truro Conservation Trust</a><br><a href="http://highlandaffordablehousing.org/" target="_page2">Highland Affordable Housing</a> <br> <a href="https://www.capecodhungernetwork.org/Food-Pantries/agentType/View/PantryID/34/Lower-Cape-Outreach-Council" target="_page2">Truro Food Pantry</a> <br> <a href="https://www.sustainablecape.org/" target="_page2">Sustainable Cape</a> ',
        },
        {
          icon: 'mdi-beach',
          title: 'Outer Cape',
          text: 'Organizations on the Outer Cape',
          html: '<a href="http://wellfleetenergyandclimateaction.org/" target="_page2">Wellfleet Energy & Climate Action Committee</a> <br> <a href="https://www.poccacapecod.org/" target="_page2">Protect Our Cape Cod Aquifer</a>',
        },
        {
          icon: 'mdi-earth',
          title: 'State and Beyond',
          text: 'Organizations related to our Mission',
          html: '<a href="https://capecodclimate.org/" target="_page2">Cape Cod Climate Change Collaborative</a><br><a href="https://www.capecodgroundwater.org/" target="_page2">Cape Cod Groundwater Guardians</a><br><a href="http://www.climatenetwork.org/" target="_page2">Climate Action Network International</a><br><a href="http://habitatcapecod.org/" target="_page2">Habitat for Humanity of Cape Cod</a>',
        },
      ],
    }),
  }
</script>
